import { z } from 'zod';

export const timestampDTOSchema = z.object({
  createdAt: z.string(),
  updatedAt: z.string(),
});
